import { useMutation } from "@tanstack/react-query";
import { postDetectDownload } from "../api/detect";

const usePostDetectDownload = () => {
  const mutation = useMutation({ mutationFn: postDetectDownload });
  return mutation;
};

export default usePostDetectDownload;
